var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBrowzwear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-1 -1 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7429 27.6638C18.7415 27.6638 18.7401 27.6639 18.7385 27.6639V27.6647H0.0117188V32.2143H23.3084C23.3084 29.7011 21.2645 27.6638 18.7429 27.6638Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63299 0C4.63144 0 4.63 0.000118954 4.62858 0.000118954V0.000832439H0.00952148V4.55038H9.19842C9.19842 2.03727 7.1545 0 4.63299 0Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00805664 22.993H14.0323H18.6021C18.6021 20.4799 16.5582 18.4426 14.0367 18.4426C14.0351 18.4426 14.0337 18.4427 14.0323 18.4427V18.4435H0.00805664V22.993Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4679 36.8853C23.4665 36.8853 23.4651 36.8854 23.4636 36.8854V36.8861H0.00708008V41.4357H28.0334C28.0334 38.9225 25.9894 36.8853 23.4679 36.8853Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2607 9.10103C15.2616 9.10103 42.3697 9.10103 42.3697 9.10103C41.4117 6.45217 38.871 4.55724 35.8849 4.55065C35.8796 4.55065 35.8746 4.55029 35.8694 4.55029C35.8641 4.55029 35.859 4.55065 35.8538 4.55065C34.2193 4.55077 9.19897 4.55059 9.19897 4.55059C9.22459 7.01703 12.549 9.10133 15.2607 9.10103Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6178 22.9933C34.6149 22.9933 34.6121 22.9932 34.6092 22.9932C34.6057 22.9932 34.6023 22.9933 34.5987 22.9933C30.8856 22.9936 18.6021 22.9932 18.6021 22.9932C18.6277 25.4595 21.9521 27.5439 24.6638 27.5435H43.8011C42.1934 25.4348 39.8718 23.8986 37.1961 23.2871C36.3668 23.0976 35.5047 22.994 34.6178 22.9933Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3091 32.2139C23.3348 34.6803 26.6591 36.7646 29.3709 36.7643L45.9226 36.7641C46.07 36.0301 46.1484 35.2713 46.1484 34.4941C46.1484 33.7135 46.0695 32.9514 45.9208 32.2145L23.3091 32.2139Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8251 45.9921C33.8251 45.9921 34.2049 46.0001 34.5833 46.0001C35.0392 46.0001 35.3401 45.9774 35.3445 45.9771C38.7895 45.755 41.8428 44.0185 43.8073 41.437H28.0337C28.0586 43.8226 31.1676 45.8621 33.8251 45.9921Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32581 9.22119C9.32426 9.22119 9.32283 9.22131 9.32128 9.22131V9.22202H-0.000244141V13.7716H13.8912C13.8912 11.2585 11.8472 9.22119 9.32581 9.22119Z",
    fill: "currentColor"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9532 18.3216C19.9541 18.3216 35.8708 18.3216 35.8716 18.3216C38.8634 18.3206 41.4098 16.4238 42.3693 13.7712H13.8916C13.9173 16.2376 17.2416 18.322 19.9532 18.3216Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrowzwear);
export default __webpack_public_path__ + "static/media/icon-browzwear.d7bb53294c265c309cad7f74431e6998.svg";
export { ForwardRef as ReactComponent };